import React from "react";
import { TYPE_PC, TYPE_SP } from "../../common/defines";
// import { gallery } from "./gallery";
import { Transportation } from "../area/Transportation";
import { Tags } from "../area/Tags";
import { modal } from "../../common/modal";
import api from "../../lib/api";
import Slider from "react-slick";
import masterData from "../../lib/masterData";
// import classnames from "classnames";
import { Link } from "../../lib/Link";
import { openContactSelector } from "../../common/callUtil"
import { banner_static } from "../../common/banner_static";
import { banner_static2 } from "../../common/banner_static2";
import { getCurrentTime } from "../../lib/currentTime";
import { isBetsukanriInHokkaido } from "../../lib/isBetsukanriInHokkaido"

/* eslint-disable complexity,max-params */
const result_one = (type, asset, detailVisible) => {
  const pref = masterData.pref.byId[asset.pref];
  const city = pref && masterData.city.byPrefAndSlug[pref.prefId][asset.city] || {};
  // const campaign = masterData.campaign.byId[asset.primaryCampaign || asset.campaigns && asset.campaigns[0]];

  // ここにデフォルトのURLを記述する
  const vrs = asset.vrs || [];

  if (type === TYPE_SP && detailVisible) {
    return (
      <div className="item">
        {!isBetsukanriInHokkaido(asset) && banner_static(type)}
        {!isBetsukanriInHokkaido(asset) && asset.premium === 1 && banner_static2(type)}
        {
          asset.isRegistFelicaObject === 1 && <Link to="/app/" className="banner"><img className="link" src="resource/img/felica_banner20201001.png" /></Link>

          /* asset.smartKeyChangeFlg === true ?
          <Link to={"/smartkey/change?assetId="+asset.assetId} className="banner"><img className="link" src="resource/img/smartkey_lp_banner.png" /></Link> :
          asset.smartKeyFlg && <Link to="/app/" className="banner"><img className="link" src="resource/img/smartkey_banner.png" /></Link>
          */
        }
        <div className="address">
          {asset.addressNavi == null ? asset.address : asset.addressNavi}
          <span
            className="go_map"
            onClick={() => {
              modal.openModal("modal_map", {
                asset,
                type,
              })
            }}
          />
        </div>

        <Transportation stationInfos={asset.stations} />

        <Tags tags={asset.tags} />

        <Slider
            dots={false}
            infinite={true}
            speed={500}
            slidesToShow={3}
            slidesToScroll={1}
          >
            {asset.images &&
            asset.images.map((imageId, index) => (
              <img
                key={index} src={api.assetImageUrl(asset.assetId, imageId, index)}
                onClick={() => modal.openModal("modal_image", { imageUrl: api.assetImageUrl(asset.assetId, imageId, index) })}
              />
            ))}
            {vrs &&
              vrs.map((item, index) => (
                <img
                  key={index} src={"resource/img/360_degrees_" + item.vrType + ".png"}
                  onClick={() => modal.openModal("modal_threed_view", { iframeUrl: item.iframeSrc })}
                />
              ))}
        </Slider>

        <div style={{
          width: "75%",
          "margin": "0 auto",
        }}>写真はイメージです。実際の仕様と異なる場合があります。</div>

        <div className="call_this_wrapper">
          <div
            className="call_this link"
            onClick={() => openContactSelector({
              asset: asset,
              eventTrackingId: 'tel_action_asset_sp',
            })}
          >
            このトランクルームを問い合わせる
          </div>
        </div>
      </div>
    );
  } else if (type === TYPE_PC) {
    return (
      <div className="item">
        <div className="title">
          <span className="titel_value"><h1>{asset.name}</h1></span>
          <span className="big_area_name">
            {pref && pref.name}
            {city && city.name}
          </span>
        </div>
        <Tags tags={asset.tags} />
        <div className="campain_box">
          {asset.campaignsVacant && asset.campaignsVacant.map((campaignId, index) => {
            const campaign = masterData.campaign.byId[campaignId];
            if (!campaign) {
              return (
                <div>
                  指定されたキャンペーン
                  {campaignId}
                  が見つかりませんでした。
                </div>
              );
            }
            return (
              <div>
                <Link to={"#campaign_detail" + campaignId}>
                  <div className="campain link">{campaign.campaignName}</div>
                </Link>
              </div>
            );
          })}
        </div>
        <div className="collection">
          <div className="first">
            <div className="value_stage price">
              <span className="value">{asset.min_price && asset.min_price.toLocaleString()}</span>
              円～
              {asset.max_price && asset.max_price.toLocaleString()}円
            </div>
          </div>
          <div className="second">
            <div className="value_stage address">
              <div className="value responder">
                <span className="addres_value">{asset.addressNavi == null ? asset.address : asset.addressNavi}</span>
                <span className="go_map" onClick={() => {
                  modal.openModal("modal_map", {
                    asset,
                    type,
                  })
                }} />
              </div>
            </div>
          </div>
          <div className="third">
            <div className="value_stage access">
              <Transportation
                stationInfos={asset.stations}
                className="value"
                itemClassName=" "
              />
            </div>
            <div
              className="call_this link"
              onClick={() => openContactSelector({
                asset: asset,
                eventTrackingId: 'tel_action_asset_pc',
              })}
            >
              このトランクルームを問い合わせる
            </div>
          </div>
        </div>
      </div>
    );
  }
};

export const detail_one = (type, asset, activeImageIndex, toggleContent, detailVisible, onSelectNextActiveImage) => {
  const pref = masterData.pref.byId[asset.pref];
  const city = pref && masterData.city.byPrefAndSlug[pref.prefId][asset.city] || {};
  const stations = asset.stations && asset.stations.map(
    stationInfo => masterData.station.byId[stationInfo.station]
  );
  // const imageId = asset.images && asset.images[activeImageIndex || 0];
  // const imageUrl = api.assetImageUrl(asset.assetId, imageId, activeImageIndex || 0);
  // const background = imageId && `url(${imageUrl})`;
  // const stationName = stations && stations[0] ? stations[0].name : '';
  // document.title=`${asset.name}（${stationName}）｜${city.name}（${stationName}）トランクルーム`;
  // const campaign = masterData.campaign.byId[asset.primaryCampaign || asset.campaigns && asset.campaigns[0]];
  const currentTime = getCurrentTime();
  return (
    <div className="detail_one">
      <div className="infomation">
        {currentTime < asset.storeopenYmdTime * 1000 &&
          <div className="open" >{asset.storeopenYmd.substring(0, 4)}年{asset.storeopenYmd.substring(5, 7)}月{asset.storeopenYmd.substring(8, 10)}日オープン予定</div>
        }
        <div className="area_title">
          <span className="area_name">
            {city.name}({stations && stations[0] && stations[0].name})
          </span>
          のトランクルーム
          <span className="type inside">
            （{masterData.assetType.bySlug[asset.assetType] && masterData.assetType.bySlug[asset.assetType].name}）
          </span>
        </div>
        <div className="sp">
          <div className="infomation">
            <div className="title_header">
            <div className="type star">{masterData.assetType.bySlug[asset.assetType].name}</div>
              {Boolean(asset.chumokuBkn) && <div className="attention">注目物件</div>}
            </div>
            <div className="title"><h1>{asset.name}</h1></div>
            <div className="price">
              {asset.min_price && asset.min_price.toLocaleString()}
              /月～
              {asset.max_price && asset.max_price.toLocaleString()}
              /月
            </div>
          </div>
          <div className="left">
            <div className="mainimg">
              <span className="arrow">
                <img
                  className="ar"
                  onClick={() => onSelectNextActiveImage(false)}
                  src="resource/img/s_arrow_left.png"
                />
              </span>
              <img
                onClick={() => onSelectNextActiveImage(true)}
                key={activeImageIndex}
                src={api.assetImageUrl(asset.assetId, asset.images[activeImageIndex], activeImageIndex)}
              />
              <span className="arrow">
                <img
                  className="ar"
                  onClick={() => onSelectNextActiveImage(true)}
                  src="resource/img/s_arrow_right.png"
                />
              </span>
            </div>
          </div>
        </div>
        {asset.campaignsVacant && asset.campaignsVacant.map((campaignId, index) => {
          const campaign = masterData.campaign.byId[campaignId];
          if (!campaign) {
            return (
              <div className="sp">
                指定されたキャンペーン
                {campaignId}
                が見つかりませんでした。
              </div>
            );
          }
          return (
            <div>
              <Link to={"#campaign_detail" + campaignId}>
                <div className="sp campaign link">{campaign.campaignName}</div>
              </Link>
              <br className="sp"/>
            </div>
          );
        })}
        <div className="sp icon" onClick={() => toggleContent(detailVisible)}>
          <div className="btn_plus">
          <span>物件詳細を{detailVisible ? '隠す' : '表示'}</span>
          <i className={"fas " + (detailVisible ? 'fa-angle-double-up' : 'fa-angle-double-down')}></i>
          </div>

        </div>
        {result_one(type, asset, detailVisible)}
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./pages/detail/detail_one.jsx